<template>
  <div>
    <a-table bordered
            rowKey="id"
            :loading="loading"
            :columns="visibleColumns"
            :data-source="deviceList"
            :pagination="pagination"
            :scroll="{ x: tableScrollX }"
            @change="handleTableChange"
            >
      <template slot="message" slot-scope="message, record">
        {{ parseFeedbackMessage(message) }}
      </template>
      <template slot="updateDate" slot-scope="updateDate, record">
        {{record.createDate}}
      </template>
    </a-table>
  </div>
</template>

<script>
import { FeedbackList} from "api/device";
import {hasPermission} from 'utils/hasPermission';

const allColumns = [
  {key: 'id', title: "记录号", align: "center", dataIndex: 'id', width: 80, perm: '/feedback/column/id'},
  {key: 'vptCode', title: "站点编码", align: "center", dataIndex: 'vptCode', width: 180, perm: '/feedback/column/vptCode'},
  {key: 'vptNum', title: "设备编码", align: "center", dataIndex: 'vptNum', width: 180, perm: '/feedback/column/vptNum'},
  {key: 'name', title: "IMEI", align: "center", dataIndex: 'name', width: 180, perm: '/feedback/column/name'},
  {key: 'nameB', title: "蓝牙名称", align: "center", dataIndex: 'nameB', width: 180, ellipsis: true, perm: '/feedback/column/nameB'},
  {key: 'message', title: '操作信息', align: "center", dataIndex: 'message', minWidth: 180, scopedSlots: { customRender: 'message' }, perm: '/feedback/column/message'},
  {key: 'pos', title: "地理位置", align: "center", dataIndex: 'pos', ellipsis: true, perm: '/feedback/column/pos'},
  {key: 'createBy', title: '操作人', align: "center", dataIndex: 'nickname', minWidth: 180, perm: '/feedback/column/createBy'},
  {key: 'updateDate', title: '开锁时间', align: "center", dataIndex: 'updateDate', ellipsis: true, scopedSlots: { customRender: 'updateDate' }, perm: '/feedback/column/updateDate'},
];

export default {
  name: 'DeviceTable',
  data() {
    let checkPending;
    let validateNickname = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('名字不能为空'));
      } else {
        callback();
      }
    };
    let validateDeviceUid = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('设备账号不能为空'));
      } else {
        callback();
      }
    };
    let validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('设备密码不能为空'));
      } else {
        callback();
      }
    };
    return {
      allColumns,
      pagination: {
        current: 1,
        pageSize: 10,
				defaultPageSize: 10,
        showQuickJumper: true,
        total: 0,
        showTotal: total => `共 ${this.pagination.total} 条数据`,
        onShowSizeChange: (current, pageSize) => this.pageSize = pageSize
      },

      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
      },

      loading: false,
      DelSpinning: false,
      infoSpinning: false,

      pageIndex: 0,
	    pageSize: 10,
      deviceName: "",

      deviceList: [],

      DELvisible: false,
      DELdeviceName: "",
      DELdeviceId: Number,

      deviceinfoVisible: false,
      deviceInfo: {
        id: "",
        deviceName: "",
        tel: "",
        deviceUid: "",
        password: "",
      },
      deviceInfoFormRules: {
        deviceName: [{ validator: validateNickname, trigger: 'change'}],
        deviceUid: [{validator: validateDeviceUid, trigger: 'change'}],
        password: [{validator: validatePassword, trigger: 'change'}],
      },
      btnShow: false,
      eventSource:{},
    };
  },
  computed: {
    visibleColumns() {
      return allColumns.filter(col => !col.perm || hasPermission(col.perm));
    },
    tableScrollX() {
      const totalWidth = this.visibleColumns.reduce((sum, col) => {
        return sum + (Number(col.width) || Number(col.minWidth) || 160);
      }, 0);
      return Math.max(totalWidth, 1200);
    }
  },
  mounted() {
    this.getDeviceListData(this.pageIndex, this.pageSize, this.deviceName);
  },
  methods: {
    parseFeedbackMessage(message) {
      if (!message) return ''
      try {
        const clean = String(message).replace(/[\r\n\t]/g, '')
        const data = JSON.parse(clean)
        return data.message || ''
      } catch (e) {
        // 非法 JSON 时直接展示原文，避免表格渲染崩溃
        return String(message)
      }
    },
    getDeviceState(message){
      if (!message) return null
      try {
        const clean = String(message).replace(/[\r\n\t]/g, '')
        const data = JSON.parse(clean)
        return data.state
      } catch (e) {
        return null
      }
    },
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      console.log("pagination------------",pagination)
      pager.current = pagination.current;
      this.pagination = pager;
      this.pageIndex = pagination.current
      this.getDeviceListData(this.pageIndex, this.pageSize, this.deviceName)
    },
    getDeviceListData(pageIndex, pageSize, deviceName) {
      console.log("getDeviceListData==========",pageIndex, pageSize, deviceName)
      this.loading = true;
      FeedbackList(pageIndex, pageSize, deviceName)
        .then(res => {
          console.log(res.data);
          if(res.data.rows.length > 0) {
            this.pagination.total = res.data.total;
            this.deviceList = res.data.rows;
            this.pageIndex = pageIndex;
            this.pagination.current = pageIndex;
            this.loading = false;
          } else {
            this.loading = false;
            this.pagination.total = 0;
            this.deviceList = []
            this.$message.error('没有查询到结果，请重试！');

          }
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        })
    },
    IntToFloat(fee) {
      return parseFloat(fee).toFixed(2);
    },
  }
}
</script>

<style lang='scss' scoped>
::v-deep .ant-table {
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

::v-deep .ant-table-container,
::v-deep .ant-table-content,
::v-deep .ant-table-body,
::v-deep .ant-table-placeholder {
  background: #fff !important;
}

::v-deep .ant-table-thead > tr > th {
  background: #33CCE0 !important;
  color: #fff !important;
  font-weight: 600;
  border-color: #7fddec !important;
}

::v-deep .ant-table-tbody > tr > td {
  background: #fff !important;
}

::v-deep .ant-table-tbody > tr:hover > td {
  background: #e6f9fc !important;
}

::v-deep .ant-table-tbody > tr.ant-table-row-selected > td {
  background: #ccf3f8 !important;
}

::v-deep .ant-table-bordered .ant-table-body > table,
::v-deep .ant-table-bordered .ant-table-fixed-left table,
::v-deep .ant-table-bordered .ant-table-fixed-right table {
  border-color: #7fddec !important;
}

::v-deep .ant-table-bordered .ant-table-thead > tr > th,
::v-deep .ant-table-bordered .ant-table-tbody > tr > td {
  border-color: #b3eaf3 !important;
}

::v-deep .ant-table-pagination.ant-pagination .ant-pagination-item-active {
  border-color: #33CCE0;
}

::v-deep .ant-table-pagination.ant-pagination .ant-pagination-item-active a {
  color: #33CCE0;
}

::v-deep .ant-pagination-prev:hover .ant-pagination-item-link,
::v-deep .ant-pagination-next:hover .ant-pagination-item-link {
  color: #33CCE0;
  border-color: #33CCE0;
}

.delDevice {
  text-align: center;
  .DelTitle {
    line-height: 45px;
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    color: #131212;
    margin-bottom: 30px;
  }
  .delIcon {
    display: inline-block;
    width: 196px;
    height: 160px;
  }
  .delHint {
    color: #212121;
    font-size: 36px;
    line-height: 90px;
  }
  .btn-wrap {
    text-align: center;
    .confirm {
      color: #fff;
      background-color: #33CCE0;
    }
  }
}
.deviceInfo-title {
  line-height: 45px;
  font-size: 28px;
  text-align: center;
  margin-bottom: 15px;
}
.deviceInfo-btn-wrap {
  text-align: center;
  margin-top: 15px;
  .btn-active {
    background-color: #33CCE0;
    color: #fff;
  }
}
</style>
